import { colors } from "@/utils/config";
const defaultGraphSettings = {
  //responsive: false,
  maintainAspectRatio: false,
  responsive: true,
  barThickness: 20,
  animation: {
    duration: 500,
},
  layout: {
   // autoPadding: true,
   // padding: 25,
   padding: {
    left: 0,
    right: 50,
    top: 25,
    bottom: 0
}
  },
  plugins: {
    autocolors: false,
    legend: {
      display: false,
    },
  },
  scales: {
    x: {
      grid: {
        display: false,
        drawBorder: false,
        drawOnChartArea: false,
        drawTicks: false,
      },
      ticks: {
        display: false,
      },
    },
    y: {
      grid: {
        display: false,
        drawBorder: false,
        drawOnChartArea: false,
        drawTicks: false,
      },
      ticks: {
        padding: 4,
        font: {
          size: 13,
        },
        callback: function (value, index, ticks) {
          const label = this.getLabelForValue(value);
          const maxLength = 32;
          const cleanLabel =
            label.length > maxLength
              ? label.substring(0, maxLength - 2) + ".."
              : label;
          return cleanLabel;
        },
      },
    },
  },
};

export const toolTipDefault = {
  titleFont: {
    weight: "normal",
    size: 12,
  },
  bodyFont: {
    weight: "normal",
    size: 12,
  },
};

const hnGraphSettings = {
  ...defaultGraphSettings,
  indexAxis: "y",
  backgroundColor: colors.lOrange,
  categoryPercentage: 1,
  //barThickness: 15,
  barThickness: 30,
  animation: {
    duration: 100,
  },
  plugins: {
    ...defaultGraphSettings.plugins,
    datalabels: {
      ...defaultGraphSettings.plugins.datalabels,
      color: colors.blue,
      align: "right",
      anchor: "end",
      padding: {
        left: 1,
      },
      font: {
        size: 13,
      },
    },
    annotation: {
      annotations: {
        line1: {
          drawTime: "afterDatasetsDraw",
          type: "line",
          mode: "vertical",
          scaleID: "x",
          value: 0,
          borderWidth: 1,
          borderColor: "black",
        },
      },
    },
    tooltip: {
      ...defaultGraphSettings.plugins.tooltip,
      ...toolTipDefault,
      callbacks: {
        label: function (context) {
          return Math.round(context.raw).toLocaleString("de-DE", {
            style: "currency",
            currency: "EUR",
            minimumFractionDigits: 0,
          });
        },
      },
    },
  },
};

const hnLeftSettings = JSON.parse(JSON.stringify(hnGraphSettings));
hnLeftSettings.plugins.datalabels.formatter = (value, context) => {
  return Math.round(value).toLocaleString("de-DE", {
    style: "currency",
    currency: "EUR",
    minimumFractionDigits: 0,
  });
};

const hnCenterSettings = JSON.parse(JSON.stringify(hnGraphSettings));
hnCenterSettings.backgroundColor = colors.blue;
hnCenterSettings.plugins.datalabels.color = colors.blue;
hnCenterSettings.scales.y.ticks.display = false;
hnCenterSettings.plugins.datalabels.formatter = (value, context) => {
  return Math.round(value).toLocaleString("de-DE", {
    style: "currency",
    currency: "EUR",
    minimumFractionDigits: 0,
  });
};
hnCenterSettings.plugins.tooltip.callbacks.label = (context) => {
  return Math.round(context.raw).toLocaleString("de-DE", {
    style: "currency",
    currency: "EUR",
    minimumFractionDigits: 0,
  });
};

const hnRightSettings = JSON.parse(JSON.stringify(hnGraphSettings));
hnRightSettings.backgroundColor = colors.lBlue;
hnRightSettings.plugins.datalabels.color = colors.blue;
hnRightSettings.plugins.datalabels.formatter = (value, context) => {
  return (Math.round(value * 10) / 10).toLocaleString("de-DE") + "%";
};
hnRightSettings.plugins.tooltip.callbacks.label = (context) => {
  return (Math.round(context.raw * 10) / 10).toLocaleString("de-DE") + "%";
};
hnRightSettings.scales.y.ticks.display = false;

export {
  defaultGraphSettings,
  hnLeftSettings,
  hnCenterSettings,
  hnRightSettings,
};
